// Matches C# GeofenceAutoArmSetting
export enum GeofenceAutoArmSetting {
  DISABLED = 'GEOFENCE_AUTO_ARM_DISARM_DISABLED',
  ONBOARD_MODE = 'GEOFENCE_AUTO_ARM_DISARM_ONBOARD_MODE',
  AWAY_MODE = 'GEOFENCE_AUTO_ARM_DISARM_AWAY_MODE',
  ALL_MODES = 'GEOFENCE_AUTO_ARM_DISARM_ALL_MODES',
}

export enum GeofenceAlertState {
  ALERT_NORMAL = 'ALERT_NORMAL',
  ALERT_ALERT = 'ALERT_ALERT',
  ALERT_CRITICAL = 'ALERT_CRITICAL',
}

// Matches C# RemoteSirenSyncMode
export enum RemoteSirenSyncMode {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  ALARM_ENABLED = 'ALARM_ENABLED',
}

// Matches C# MessageBeepSettingEnum
export enum MessageBeepSetting {
  DISABLED = 'MESSAGE_BEEP_DISABLED',
  ONCE = 'MESSAGE_BEEP_ONCE',
  CONTINUOUS = 'MESSAGE_BEEP_CONTINUOUS',
}

export enum VMSFormsRegion {
  NONE = 'NONE',
  US = 'US',
  CARIBBEAN = 'CARIBBEAN',
  EUROPE = 'EUROPE',
}

export enum VMSAgency {
  NONE = 'NONE',
  NOAA = 'NOAA',
  CUSTOM = 'CUSTOM',
}
